// extracted by mini-css-extract-plugin
module.exports = {"jcGrey600":"#414c55","customAttributeContainer":"RadiusUserGroupWrap__customAttributeContainer","header":"RadiusUserGroupWrap__header"};